<template>
  <v-navigation-drawer
    v-model="showNav"
    app
  >
    <v-toolbar
      id="app-sidebar"
      flat
    >
      <form
        class="search"
        @submit.prevent="searchProducts"
      >
        <v-text-field
          v-model.trim="searchValue"
          label="search"
          placeholder="Search Products"
          solo
          append-icon="search"
          @click:append="searchProducts"
        />
      </form>
    </v-toolbar>
    <v-divider />
    <v-list expand>
      <div
        v-if="loading"
        class="text-xs-center"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </div>
      <v-list-group
        v-for="item in categories"
        :key="item.title"
        v-model="item.active"
      >
        <v-list-tile
          slot="activator"
          class="iconpadding"
        >
          <v-list-tile-avatar size="30">
            <font-awesome-icon :icon="item.action" />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ transModalName(item.model) }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          avatar
          exact
          :to="getRoute(item.model, 'all', false)"
        >
          <v-list-tile-avatar size="30">
            <v-icon>apps</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ $t("message.all") }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-avatar>
            {{ item.count }}
          </v-list-tile-avatar>
        </v-list-tile>
        <v-list-tile
          v-for="subItem in item.items"
          :key="subItem.code"
          avatar
          exact
          :to="getRoute(item.model, subItem.code, true)"
        >
          <v-list-tile-avatar
            tile
            size="30"
          >
            <img :src="subItem.image.avatar">
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ subItem.name }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-avatar>
            {{ subItem.count }}
          </v-list-tile-avatar>
        </v-list-tile>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapMutations } from 'vuex'
import { findBy } from 'utils/utils.js'

export default {
  props: {
    value: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      categories: [],
      searchIsLoading: false,
      searchItems: [],
      searchModel: null,
      searchValue: null,
      loading: true,
      scrollTop: 0
    }
  },
  computed: {
    showNav: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        const content = this.$parent.$children[2].$el
        if (!newValue) {
          // 오버레이 너머로 클릭되는거 방지
          content.classList.add('dont-touch')
          setTimeout(() => {
            content.classList.remove('dont-touch')
          }, 100)
        }
        this.$emit('input', newValue)
      }
    }
  },
  created () {
    this.$eventBus.$on('changeLocale', this.eventBusforCategories)
  },
  beforeMount () {
    this.eventBusforCategories()
  },
  beforeDestroy () {
    this.$eventBus.$off('changeLocale')
  },
  methods: {
    ...mapMutations({
      flush: 'flush'
    }),
    eventBusforCategories: function () {
      this.loading = true
      this.categories = []
      this.getCategories()
    },
    transModalName: function (value) {
      const key = 'variables.' + value
      return this.$t(key)
    },
    searchProducts: function () {
      if (!this.searchValue) {
        return
      }
      this.$router.push({ path: `/${this.$language.locale}/search`, query: { value: this.searchValue } })
    },
    getAction: function (modelName) {
      let value = null
      if (modelName === 'MediaContent') {
        value = 'video'
      } else if (modelName === 'LicensedProducts') {
        value = 'tags'
      } else {
        value = 'star'
      }
      return value
    },
    getCategories: function () {
      let productType = null
      let categories = []
      if (!this.$route.params.lang) {
        this.$route.params.lang = this.$language.locale
      }
      this.$http.get('/api/categories/', { params: this.$route.params })
        .then(response => {
          categories = response.data.results
          for (let i = 0; i < categories.length; i++) {
            let category = categories[i]
            productType = findBy(
              this.categories,
              category.product.name,
              object => { return object.title }
            )
            if (productType === null) {
              this.categories.push({
                action: this.getAction(category.product.model),
                model: category.product.model,
                title: category.product.name,
                items: []
              })
              productType = this.categories.length - 1
            }
            this.categories[productType].items.push({
              id: category.id,
              name: category.name,
              image: category.image,
              code: category.code,
              count: category.catalog_length
            })
            let categoryProductTypeCount = 0
            this.categories[productType].items.forEach(element => {
              categoryProductTypeCount += element.count
            })
            this.categories[productType].count = categoryProductTypeCount
          }
          this.loading = false
          if (this.$route.name.includes('_')) {
            let routeName = this.$route.name.split('_')[0]
            let categoryIndex = findBy(
              this.categories,
              routeName,
              object => { return object.model.toLowerCase() }
            )
            if (categoryIndex !== undefined && this.categories[categoryIndex]) {
              this.categories[categoryIndex].active = true
            }
          }
          const index = this.categories.findIndex(category => category.model === 'LicensedProducts')
          if (index !== -1) {
            this.$store.commit('setLicensedProductsCategories', this.categories[index]['items'])
          } else {
            this.$store.commit('setLicensedProductsCategories', [])
          }

          const indexPinkfong = this.categories.findIndex(category => category.model === 'PinkfongProducts')
          if (indexPinkfong !== -1) {
            this.$store.commit('setPinkfongProductsCategories', this.categories[indexPinkfong]['items'])
          } else {
            this.$store.commit('setPinkfongProductsCategories', [])
          }
        })
        .catch(err => {
          console.log(err)
        }) // 예외처리
    },
    getRoute: function (modelName, pageType, isCategory) {
      modelName = modelName.toLowerCase()
      let path = '/' + this.$language.locale + '/' + modelName + '/' + pageType
      if (isCategory) {
        return { path: path, params: { category: pageType } }
      } else {
        return { path: path }
      }
    }
  }
}
</script>
<style>
  .v-text-field.v-text-field--solo .v-input__control {
    min-height: 15px;
    margin-right: 20px;
  }
  .search {
    width: 100%;
  }
  .iconpadding .v-list__tile__avatar {
    min-width: 40px;
  }
  .v-overlay--active {
    transform: translateX(300px) !important;
  }
  .dont-touch {
    touch-action: none !important;
    pointer-events: none !important;
  }

  #app-sidebar .v-toolbar__content{
    height: 56px !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/SideNav.vue